import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from 'react';
import { createPolymorphicComponent } from '../../helpers/react/polymorphicComponentTypes';
import { useStyles } from '../../hooks/useStyles';
import { FieldBase } from '../FieldBase';
import { fieldStyles } from './Field.styles';
export const Field = createPolymorphicComponent(forwardRef(function Field(props, forwardedRef) {
    const { styles, sx, innerStyles, populated: populatedProp, placeholder, children, ...other } = props;
    const { getStyles, globalStyles } = useStyles({
        name: 'Field',
        styles: [fieldStyles, styles],
    });
    const populated = populatedProp ?? (!!children || !!placeholder);
    return (_jsx(FieldBase, { styles: innerStyles?.fieldBase, populated: populated, ...other, sx: [globalStyles, sx], ref: forwardedRef, children: children ? (_jsx("div", { ...getStyles('value'), "data-cy": 'value', children: children })) : placeholder ? (_jsx("div", { ...getStyles('placeholder', other.disabled && 'placeholder$disabled'), "data-cy": 'placeholder', children: placeholder })) : null }));
}));
